import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import { makeStyles } from '@mui/styles';

export const styles = css`
  .container {
    font-size: 16px;
    color: ${colors.G4};
    padding: 16px 24px;
    margin-top: 72px;
  }

  .srp-outer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 72px;
  }

  .sticky-bar {
    z-index: 1;
  }

  .srp-inner {
    width: 100%;
    max-width: 1392px;
    padding: 16px 24px;
    display: flex;
    gap: 24px;
  }

  @media (max-width: ${screen.xsMax}) {
    .srp-inner {
      padding: 0 0 16px 0;
    }
  }

  .srp-right-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .srp-sidebar {
    max-width: 330px;
  }

  @media (max-width: ${screen.mdMax}) {
    .srp-sidebar {
      display: none;
    }
  }

  .filters-desktop {
    width: 100%;
    max-width: 1038px;
    display: flex;
  }

  @media (max-width: ${screen.smMin}) {
    .filters-desktop {
      display: none;
    }
  }

  .sidebar-ad {
    margin-bottom: 24px;
  }

  .sidebar-ads {
    position: relative;
  }

  .sticky-sidebar-ads {
    position: sticky;
    top: 0;
  }

  .full-width {
    width: 100%;
  }
`;

export const useStyles = makeStyles(() => ({
  appBar: {
    zIndex: 1,
  },
}));
